import { useModalStore } from '@/stores/apostatudo/modal';
import AnnouncementModal from '@/components/apostatudo/organisms/AnnouncementModal.vue';

// Bloqueia o acesso a /games e /sports (e subrotas) redirecionando pra home e
// reabrindo o popup de aviso. Abrir o popup direto pelo store garante feedback
// mesmo quando o usuário já está na home (navigateTo pra mesma rota é no-op e
// não remonta a página). Complemento do modo "site em ajustes".
// Só age com os jogos pausados no core (Operações do site, ENG-915).
export default defineNuxtRouteMiddleware((to) => {
  const { isGamesPaused } = useFeatureFlagsNew();

  if (!isGamesPaused.value) {
    return;
  }

  const blocked = ['/games', '/sports'];

  const isBlocked = blocked.some(
    (path) => to.path === path || to.path.startsWith(`${path}/`),
  );

  if (!isBlocked) {
    return;
  }

  if (import.meta.client) {
    const { open } = useModalStore();

    open(AnnouncementModal, { variant: 'games' });
  }

  return navigateTo('/');
});
